/**
 * 1.5.1: 组织相关工具函数
 * 提供组织名称格式化等功能
 */

// 硬编码的工作区后缀（数据库中可能存储的格式）
const WORKSPACE_SUFFIXES = [
  "'s Workspace",      // 英文
  "のワークスペース",    // 日文
  "的工作区",           // 中文
];

/**
 * 格式化组织名称，将硬编码的工作区后缀替换为当前语言的翻译
 * @param name 组织名称
 * @param t i18n 翻译函数
 * @returns 格式化后的组织名称
 */
export function formatOrganizationName(name: string, t: (key: string) => string): string {
  for (const suffix of WORKSPACE_SUFFIXES) {
    if (name.endsWith(suffix)) {
      const username = name.slice(0, -suffix.length);
      return `${username}${t('workspaceSuffix')}`;
    }
  }
  return name;
}
